import React from 'react';

import './AnalyticsNetworkNewsroomOverview.scss';

import Tooltips from '../../atoms/Tooltip/Tooltip';

// import * as moment from 'moment';

const AnalyticsNetworkNewsroomOverview = ({ loading, responseData, overallDataSetType }) => {
  return (
    <>
      <div className="tmx-analyticsNetworkNewsroomOverview__clearedGrid tmx-analyticsNetworkNewsroomOverview__clearedGrid--top">
        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New newsroom accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.users?.total_network_users}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                Total network users
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}
        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New newsroom accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.users?.nr_engaged}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Engaged Newsrooms orgs
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}
        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New user accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.users?.nr_users_engaged}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Engaged Newsroom users
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}
        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New newsroom accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.users?.nr_new}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                New Newsroom users
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}
      </div>
      {overallDataSetType === 'This Week' || overallDataSetType === 'This Month' ? (
        <div className="tmx-analyticsNetworkNewsroomOverview__clearedGrid">
          {loading && overallDataSetType === 'This Week' ? (
            <>
              <div className="tmx-analyticsDashboard__clearedBubble">
                <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphTitle"></div>
                <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphSubTitle"></div>
              </div>
            </>
          ) : overallDataSetType === 'This Week' ? (
            <div className="tmx-analyticsNetworkNewsroomOverview__iframeItem">
              <iframe
                src="https://embed.tmxdata.io/public/question/8ac1688d-cd87-481a-9d15-3c34e928608c"
                frameborder="0"
                width="100%"
                height="100%"
                title="3c34e928608c"
                allowtransparency></iframe>
            </div>
          ) : null}

          {loading && overallDataSetType === 'This Month' ? (
            <div className="tmx-analyticsDashboard__clearedBubble">
              <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphTitle"></div>
              <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphSubTitle"></div>
            </div>
          ) : overallDataSetType === 'This Month' ? (
            <div className="tmx-analyticsNetworkNewsroomOverview__iframeItem">
              <iframe
                src="https://embed.tmxdata.io/public/question/2253f466-2cb2-4908-863a-687b7de6ed91"
                frameborder="0"
                width="100%"
                height="100%"
                title="687b7de6ed91"
                allowtransparency></iframe>
            </div>
          ) : null}
        </div>
      ) : null}
      <div className="tmx-analyticsNetworkNewsroomOverview__topTextContainer">
        <div className="tmx-analyticsNetworkNewsroomOverview__topTextContainerLeft">
          <h1 className="tmx-analyticsNetworkNewsroomOverview__topTextTitle">
            Mission-critical KPIs
          </h1>
          <h1 className="tmx-analyticsNetworkNewsroomOverview__topTextSubTitle">
            This information is confidential.{' '}
          </h1>
        </div>
      </div>
      <div className="tmx-analyticsNetworkNewsroomOverview__clearedGrid tmx-analyticsNetworkNewsroomOverview__clearedGrid--top">
        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Users engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.messenger?.average_reply_time_minutes}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Average reply time
                <br />
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Newsrooms engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.messenger?.requests_no_reply_30min}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                No reply in 30 min
                <br />
                {/* (Unique) */}
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New user accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle--variation">
                {responseData?.messenger
                  ? Object.keys(responseData?.messenger?.requests_no_reply_by_category)[0]
                  : null}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                No reply by category
                <br />
              </h1>
            </Tooltips>
          </div>
        )}
      </div>
      {overallDataSetType === 'This Week' || overallDataSetType === 'This Month' ? (
        <div className="tmx-analyticsNetworkNewsroomOverview__clearedGrid">
          {loading && overallDataSetType === 'This Week' ? (
            <>
              <div className="tmx-analyticsDashboard__clearedBubble">
                <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphTitle"></div>
                <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphSubTitle"></div>
              </div>
            </>
          ) : overallDataSetType === 'This Week' ? (
            <div className="tmx-analyticsNetworkNewsroomOverview__iframeItem">
              <iframe
                src="https://embed.tmxdata.io/public/question/63cfe31e-cd26-4d2c-90a6-213421354449"
                frameborder="0"
                width="100%"
                height="100%"
                title="213421354449"
                allowtransparency></iframe>
            </div>
          ) : null}

          {loading && overallDataSetType === 'This Month' ? (
            <div className="tmx-analyticsDashboard__clearedBubble">
              <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphTitle"></div>
              <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphSubTitle"></div>
            </div>
          ) : overallDataSetType === 'This Month' ? (
            <div className="tmx-analyticsNetworkNewsroomOverview__iframeItem">
              <iframe
                src="https://embed.tmxdata.io/public/question/a3287f4b-c8a4-4876-9781-dca91861d9dc"
                frameborder="0"
                width="100%"
                height="100%"
                title="dca91861d9dc"
                allowtransparency></iframe>
            </div>
          ) : null}
        </div>
      ) : null}
      <div className="tmx-analyticsNetworkNewsroomOverview__topTextContainer">
        <div className="tmx-analyticsNetworkNewsroomOverview__topTextContainerLeft">
          <h1 className="tmx-analyticsNetworkNewsroomOverview__topTextTitle">
            TMX messenger requests KPIs
          </h1>
          <h1 className="tmx-analyticsNetworkNewsroomOverview__topTextSubTitle">
            This information is confidential.{' '}
          </h1>
        </div>
      </div>
      {overallDataSetType === 'This Week' || overallDataSetType === 'This Month' ? (
        <div className="tmx-analyticsNetworkNewsroomOverview__clearedGrid">
          {loading && overallDataSetType === 'This Week' ? (
            <>
              <div className="tmx-analyticsDashboard__clearedBubble">
                <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphTitle"></div>
                <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphSubTitle"></div>
              </div>
              <div className="tmx-analyticsDashboard__clearedBubble">
                <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphTitle"></div>
                <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphSubTitle"></div>
              </div>
            </>
          ) : overallDataSetType === 'This Week' ? (
            <div className="tmx-analyticsNetworkNewsroomOverview__iframeItem">
              <iframe
                src="https://embed.tmxdata.io/public/question/68de7852-f09d-47c0-b40a-4f59217f3bcc"
                frameborder="0"
                width="100%"
                height="100%"
                title="4f59217f3bcc"
                allowtransparency></iframe>
            </div>
          ) : null}

          {loading && overallDataSetType === 'This Month' ? (
            <div className="tmx-analyticsDashboard__clearedBubble">
              <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphTitle"></div>
              <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphSubTitle"></div>
            </div>
          ) : overallDataSetType === 'This Month' ? (
            <div className="tmx-analyticsNetworkNewsroomOverview__iframeItem">
              <iframe
                src="https://embed.tmxdata.io/public/question/994faa0d-9e75-4068-b4fc-27c2e655f357"
                frameborder="0"
                width="100%"
                height="100%"
                title="27c2e655f357"
                allowtransparency></iframe>
            </div>
          ) : null}
        </div>
      ) : null}
      <div className="tmx-analyticsNetworkNewsroomOverview__clearedGrid tmx-analyticsNetworkNewsroomOverview__clearedGrid--top">
        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Users engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.messenger?.nr_count}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Total Newsroom requests
                <br />
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Newsrooms engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.messenger?.nr_users}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Total Newsroom request users
                <br />
                {/* (Unique) */}
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New user accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.messenger?.nr_first_timers}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                First time requests
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New newsroom accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.messenger?.nr_two_day_streaks}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Request two day streak
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}
      </div>
      <div className="tmx-analyticsNetworkNewsroomOverview__clearedGrid tmx-analyticsNetworkNewsroomOverview__clearedGrid--top">
        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Users engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.messenger?.nr_back_after_while}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Requests after while
                <br />
              </h1>
            </Tooltips>
          </div>
        )}
      </div>
    </>
  );
};

AnalyticsNetworkNewsroomOverview.propTypes = {};

export default AnalyticsNetworkNewsroomOverview;
